import React from 'react'
import agent from '../agent'
import Loading from './widgets/Loading'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {
    CHAT_POST_DETAIL_LOADED,
    CHAT_POST_DETAIL_UNLOADED,
    CHAT_POST_DELETE,
    CHAT_POST_TOGGLE_DISPLAY
} from '../constants/actionTypes'
import dateHelper from '../util/dateFormatter'
import numberHelper from '../util/numberFormatter'

const mapStateToProps = state => ({
    ...state.chat,
    currentUser: state.common.currentUser
});

const mapDispatchToProps = dispatch => ({
    onLoad: payload =>
        dispatch({ type: CHAT_POST_DETAIL_LOADED, payload }),
    onUnload: () =>
        dispatch({ type: CHAT_POST_DETAIL_UNLOADED }),
    onDelete: (payload) => {
        dispatch({ type: CHAT_POST_DELETE, payload })
    },
    onTogglePostDisplay: (payload) => {
        dispatch({ type: CHAT_POST_TOGGLE_DISPLAY, payload })
    }
});

class PostDetail extends React.Component {
    constructor() {
        super()
        this.toggleDisplay = (key, display) => ev => {
            const payload = agent.Chats.togglePostDisplay(key, display)
            this.props.onTogglePostDisplay(payload)
        }
        this.delete = (key) => ev => {
            const payload = agent.Chats.deleteChatPost(key)
            this.props.onDelete(payload)
        }
    }
    componentWillMount() {
        this.props.onLoad(
            agent.Chats.getPostDetail(this.props.match.params.postkey)
        );
    }

    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {
        if (!this.props.post) {
            return (
                <Loading />
            )
        }
        return (
            <div class='pane'>
                <Link className="crumb" to={`/channels/${this.props.match.params.key}`}>&laquo; back to channel</Link>

                <h1>Post Detail</h1>
                <div className="infoGroup">
                    <div className="infoPair">
                        <label>Key:</label> <span>{this.props.post.key} </span>
                    </div>
                    <div className="infoPair">
                        <label>Created:</label> <span>{dateHelper.Formatter.toLocalString(this.props.post.created)}</span>
                    </div>
                    <div className="infoPair">
                        <label>Post:</label> <span>{this.props.post.post}</span>
                    </div>
                    <div className="infoPair">
                        <label>User:</label> <span><Link to={`/users/${this.props.post.userkey}`}>{this.props.post.username}</Link></span>
                    </div>
                    <div className="infoPair">
                        <label>Display:</label> <span>{this.props.post.display ? 'Yes' : 'No'}</span>
                    </div>
                </div>
                <div className="infoGroup">
                    <div className="infoAction">
                        <button className="buttonAction" onClick={this.toggleDisplay(this.props.match.params.postkey, this.props.post.display ? false : true)}>{this.props.post.display ? 'Do not display' : 'Display'}</button>
                        <button className="buttonAction" onClick={this.delete(this.props.match.params.postkey)}>{'Delete'}</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PostDetail);



// WEBPACK FOOTER //
// ./src/components/PostDetail.js